import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { configureBudgetStyles } from "@insite/content-library/Widgets/Budget/ConfigureBudget";
import { css } from "styled-components";

configureBudgetStyles.twoButtonModalStyles = mergeToNew(configureBudgetStyles.twoButtonModalStyles, {
    submitButton: {
        color: "common.accent",
        css: css`
            color: white;
        `,
    },
});
